"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteAddressResponseToJSON = exports.AutocompleteAddressResponseFromJSONTyped = exports.AutocompleteAddressResponseFromJSON = void 0;
var _1 = require("./");
function AutocompleteAddressResponseFromJSON(json) {
    return AutocompleteAddressResponseFromJSONTyped(json, false);
}
exports.AutocompleteAddressResponseFromJSON = AutocompleteAddressResponseFromJSON;
function AutocompleteAddressResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'addresses': (json['addresses'].map(_1.AutocompleteAddressResponseAddressesFromJSON)),
    };
}
exports.AutocompleteAddressResponseFromJSONTyped = AutocompleteAddressResponseFromJSONTyped;
function AutocompleteAddressResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'addresses': (value.addresses.map(_1.AutocompleteAddressResponseAddressesToJSON)),
    };
}
exports.AutocompleteAddressResponseToJSON = AutocompleteAddressResponseToJSON;
